export default __webpack_public_path__ + "4e70d437aa1026f04383c20aa628a006.svg";